import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaChartBar,
  FaBuilding,
  FaFlask,
  FaTv,
  FaShieldAlt,
  FaClipboardList,
  FaCalendarAlt,
  FaFilter,
  FaDownload,
  FaSync,
} from "react-icons/fa";
import { SipDropdown } from "../../components/form/SipControls";
import {
  LineChart,
  Line,
  AreaChart,
  Area,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  RadialBarChart,
  RadialBar,
  ComposedChart,
} from "recharts";
import Api from "../../api";
import dayjs from "dayjs";

function StatistikPage() {
  const navigate = useNavigate();


  // ==================== STATE MANAGEMENT ====================
  const [loading, setLoading] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("bulan");
  const [selectedModule, setSelectedModule] = useState("semua");
  const [asets,setAsets]= useState([]);
  
  const getAset=async()=>{
    try {
      const res = await Api.get("/mon/data-statistik");
      // Menggunakan data dari endpoint statInventaris yang mengembalikan data per tahun
      if (res.data && res.data.data) {
        setAsets(res.data.data);
      } else {
        setAsets([]);
      }
      console.log(res.data.data)
    } catch (error) {
      console.error("Error fetching inventaris data:", error);
      setAsets([]);
    }
  }


  // Data states untuk setiap modul dengan data dummy
  const [atkData, setAtkData] = useState([
    { id: 1, nama: "Pulpen Pilot", stokAwal: 50, status: "Aman" },
    { id: 2, nama: "Kertas A4", stokAwal: 15, status: "Menipis" },
    { id: 3, nama: "Spidol Whiteboard", stokAwal: 8, status: "Habis" },
    { id: 4, nama: "Stapler Kenko", stokAwal: 25, status: "Aman" },
    { id: 5, nama: "Penggaris 30cm", stokAwal: 12, status: "Menipis" },
    { id: 6, nama: "Lem Stick", stokAwal: 30, status: "Aman" },
    { id: 7, nama: "Correction Tape", stokAwal: 18, status: "Aman" },
    { id: 8, nama: "Amplop Coklat", stokAwal: 5, status: "Habis" },
  ]);
  const [inventarisLabData, setInventarisLabData] = useState([
    { id: 1, nama: "Mikroskop Olympus", kondisi: "baik", lab_id: 1 },
    { id: 2, nama: "Bunsen Burner", kondisi: "rusak", lab_id: 1 },
    { id: 3, nama: "Beaker Glass 500ml", kondisi: "baik", lab_id: 2 },
    { id: 4, nama: "pH Meter Digital", kondisi: "baik", lab_id: 2 },
    { id: 5, nama: "Centrifuge", kondisi: "rusak", lab_id: 3 },
    { id: 6, nama: "Pipet Mikro", kondisi: "baik", lab_id: 3 },
    { id: 7, nama: "Autoclave", kondisi: "", lab_id: 1 },
    { id: 8, nama: "Incubator", kondisi: "baik", lab_id: 2 },
  ]);
  const [perawatanAsetData, setPerawatanAsetData] = useState([
    { id: 1, nama: "Laptop Dell", status: "selesai", jenis_kerusakan: "Hardware" },
    { id: 2, nama: "Proyektor Epson", status: "proses", jenis_kerusakan: "Software" },
    { id: 3, nama: "AC Split", status: "dijadwalkan", jenis_kerusakan: "Maintenance" },
    { id: 4, nama: "Printer Canon", status: "selesai", jenis_kerusakan: "Hardware" },
    { id: 5, nama: "CCTV Camera", status: "proses", jenis_kerusakan: "Network" },
    { id: 6, nama: "Server Rack", status: "selesai", jenis_kerusakan: "Maintenance" },
  ]);
  const [auditKeamananData, setAuditKeamananData] = useState([
    { id: 1, gupeg: "John Doe", jenis_perangkat: "laptop", hasil: "Aman" },
    { id: 2, gupeg: "Jane Smith", jenis_perangkat: "desktop", hasil: "Perlu Update" },
    { id: 3, gupeg: "Bob Wilson", jenis_perangkat: "laptop", hasil: "Berisiko" },
    { id: 4, gupeg: "Alice Brown", jenis_perangkat: "tablet", hasil: "Aman" },
    { id: 5, gupeg: "Charlie Davis", jenis_perangkat: "mobile", hasil: "Aman" },
    { id: 6, gupeg: "Diana Miller", jenis_perangkat: "desktop", hasil: "Perlu Update" },
  ]);
  const [monitoringData, setMonitoringData] = useState([]);

 

  // ==================== WARNA UNTUK CHART ====================
  const COLORS = {
    primary: "#3B82F6",
    secondary: "#10B981",
    warning: "#F59E0B",
    danger: "#EF4444",
    info: "#06B6D4",
    purple: "#8B5CF6",
    pink: "#EC4899",
    indigo: "#6366F1",
  };

  const PIE_COLORS = [
    COLORS.primary,
    COLORS.secondary,
    COLORS.warning,
    COLORS.danger,
    COLORS.info,
    COLORS.purple,
  ];

  // ==================== API FUNCTIONS ====================
  
  // Fungsi untuk mengambil data ATK
  const fetchAtkData = async () => {
    try {
      const response = await Api.get("/mon/atk");
      const atks = response.data.data || [];
      const masuks = response.data.masuk || [];
      const keluars = response.data.keluar || [];

      // Proses data untuk statistik
      const processedData = atks.map((item) => {
        const totalMasuk = masuks
          .filter((masuk) => masuk.atk_id === item.id)
          .reduce((total, masuk) => total + (masuk.jml || 0), 0);
        
        const totalKeluar = keluars
          .filter((keluar) => keluar.atk_id === item.id)
          .reduce((total, keluar) => total + (keluar.vol || 0), 0);
        
        const stokAkhir = (item.stokAwal || 0) + totalMasuk - totalKeluar;
        
        return {
          ...item,
          totalMasuk,
          totalKeluar,
          stokAkhir,
          status: stokAkhir <= 10 ? "Habis" : stokAkhir <= 20 ? "Menipis" : "Aman",
        };
      });

      if (processedData.length > 0) {
        setAtkData(processedData);
      }
    } catch (error) {
      console.error("Error fetching ATK data:", error);
    }
  };

  // Fungsi untuk mengambil data Inventaris Lab
  const fetchInventarisLabData = async () => {
    try {
      const response = await Api.get("/mon/inv-lab");
      if (response.data.data && response.data.data.length > 0) {
        setInventarisLabData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Inventaris Lab data:", error);
    }
  };

  // Fungsi untuk mengambil data Perawatan Aset
  const fetchPerawatanAsetData = async () => {
    try {
      const response = await Api.get("/mon/perawatan-aset");
      if (response.data.data && response.data.data.length > 0) {
        setPerawatanAsetData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Perawatan Aset data:", error);
    }
  };

  // Fungsi untuk mengambil data Audit Keamanan
  const fetchAuditKeamananData = async () => {
    try {
      const response = await Api.get("/mon/audit-keamanan");
      if (response.data.data && response.data.data.length > 0) {
        setAuditKeamananData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Audit Keamanan data:", error);
    }
  };

  // Fungsi untuk mengambil semua data
  const fetchAllData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        fetchAtkData(),
        fetchInventarisLabData(),
        fetchPerawatanAsetData(),
        fetchAuditKeamananData(),
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // ==================== DATA PROCESSING ====================

  // Data untuk Statistik ATK (Pie Chart)
  const atkStokData = [
    {
      name: "Stok Aman",
      value: atkData.filter((item) => item.status === "Aman").length,
      color: COLORS.secondary,
    },
    {
      name: "Stok Menipis",
      value: atkData.filter((item) => item.status === "Menipis").length,
      color: COLORS.warning,
    },
    {
      name: "Stok Habis",
      value: atkData.filter((item) => item.status === "Habis").length,
      color: COLORS.danger,
    },
  ];

  // Data untuk Inventaris Lab (Bar Chart)
  const inventarisLabKondisiData = [
    {
      name: "Kondisi Baik",
      jumlah: inventarisLabData.filter((item) => item.kondisi?.toLowerCase() === "baik").length,
      fill: COLORS.secondary,
    },
    {
      name: "Kondisi Rusak",
      jumlah: inventarisLabData.filter((item) => item.kondisi?.toLowerCase() === "rusak").length,
      fill: COLORS.danger,
    },
  ];

  // Data untuk Perawatan Aset (Area Chart)
  const perawatanStatusData = [
    {
      name: "Selesai",
      jumlah: perawatanAsetData.filter((item) => item.status === "selesai").length,
      fill: COLORS.secondary,
    },
    {
      name: "Dalam Proses",
      jumlah: perawatanAsetData.filter((item) => item.status === "proses").length,
      fill: COLORS.warning,
    },
    {
      name: "Dijadwalkan",
      jumlah: perawatanAsetData.filter((item) => item.status === "dijadwalkan").length,
      fill: COLORS.info,
    },
  ];

  // Data untuk Audit Keamanan (Radial Bar Chart)
  const auditKeamananStatusData = [
    {
      name: "Aman",
      value: auditKeamananData.filter((item) => item.hasil === "Aman").length,
      fill: COLORS.secondary,
    },
    {
      name: "Perlu Update",
      value: auditKeamananData.filter((item) => item.hasil === "Perlu Update").length,
      fill: COLORS.warning,
    },
    {
      name: "Berisiko",
      value: auditKeamananData.filter((item) => item.hasil === "Berisiko").length,
      fill: COLORS.danger,
    },
  ];

  // Data untuk Trend Bulanan (Line Chart)
  const trendBulananData = [
    { bulan: "Jan", atk: 45, inventaris: 32, perawatan: 12, audit: 8 },
    { bulan: "Feb", atk: 52, inventaris: 28, perawatan: 15, audit: 12 },
    { bulan: "Mar", atk: 48, inventaris: 35, perawatan: 18, audit: 10 },
    { bulan: "Apr", atk: 61, inventaris: 42, perawatan: 22, audit: 15 },
    { bulan: "Mei", atk: 55, inventaris: 38, perawatan: 20, audit: 13 },
    { bulan: "Jun", atk: 67, inventaris: 45, perawatan: 25, audit: 18 },
  ];

  // Data untuk Statistik Inventaris berdasarkan Tahun (Bar Chart)
  const inventarisTahunData = () => {
    // Jika data sudah dalam format yang benar dari backend (tahun, total)
    if (asets.length > 0 && asets[0].hasOwnProperty('tahun') && asets[0].hasOwnProperty('total')) {
      return asets.map(item => ({
        tahun: item.tahun.toString(),
        jumlah: item.total
      }));
    }
    
    // Fallback: jika data masih dalam format lama, proses manual
    const tahunCount = {};
    asets.forEach(item => {
      const tahun = dayjs(item.tgl).year();
      tahunCount[tahun] = (tahunCount[tahun] || 0) + 1;
    });
    
    // Urutkan berdasarkan tahun
    return Object.keys(tahunCount)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map(tahun => ({
        tahun: tahun,
        jumlah: tahunCount[tahun]
      }));
  };

  // Data untuk Overview Cards
  const overviewData = [
    {
      title: "Total ATK",
      value: atkData.length,
      icon: FaBuilding,
      color: "bg-primary",
      change: "+12%",
      changeType: "positive",
    },
    {
      title: "Inventaris Lab",
      value: inventarisLabData.length,
      icon: FaFlask,
      color: "bg-accent",
      change: "+8%",
      changeType: "positive",
    },
    {
      title: "Perawatan Aset",
      value: perawatanAsetData.length,
      icon: FaTv,
      color: "bg-primary/80",
      change: "-3%",
      changeType: "negative",
    },
    {
      title: "Total Inventaris",
      value: asets.length,
      icon: FaShieldAlt,
      color: "bg-warning",
      change: "+15%",
      changeType: "positive",
    },
  ];

  // ==================== EVENT HANDLERS ====================
  const handleBack = () => {
    navigate(-1);
  };

  const handleRefresh = () => {
    fetchAllData();
  };

  const handleExport = () => {
    // Implementasi export data
    console.log("Export data...");
  };

  // ==================== EFFECTS ====================
  useEffect(() => {
    fetchAllData();
    getAset();
  }, []);

  // ==================== CUSTOM COMPONENTS ====================
  
  // Custom Tooltip untuk Chart
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
          <p className="font-medium text-gray-900">{label}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: entry.color }} className="text-sm">
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  // Loading State
  if (loading) {
    return (
      <div className="space-y-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center h-96">
            <div className="text-center">
              <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary mx-auto mb-4"></div>
              <p className="text-gray-600">Memuat data statistik...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* ==================== HEADER SECTION ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="bg-primary px-6 py-8 md:px-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              {/* Judul Halaman */}
              <div className="text-white">
                <div className="flex items-center gap-3 mb-2">
                  <motion.div
                    animate={{ rotate: [0, 360] }}
                    transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                    className="p-2 bg-white/20 rounded-xl backdrop-blur-sm"
                  >
                    <FaChartBar className="text-xl" />
                  </motion.div>
                  <h1 className="text-2xl md:text-3xl font-bold">
                    Dashboard Statistik
                  </h1>
                </div>
                <p className="text-white/80 text-sm md:text-base">
                  Analisis komprehensif data sistem informasi monitoring
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex items-center gap-3">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleRefresh}
                  className="flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/20 px-4 py-3 rounded-xl hover:bg-white/20 transition-all duration-300"
                >
                  <FaSync className="text-sm" />
                  <span className="font-medium">Refresh</span>
                </motion.button>

                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleExport}
                  className="flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/20 px-4 py-3 rounded-xl hover:bg-white/20 transition-all duration-300"
                >
                  <FaDownload className="text-sm" />
                  <span className="font-medium">Export</span>
                </motion.button>

                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleBack}
                  className="flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/20 px-4 py-3 rounded-xl hover:bg-white/20 transition-all duration-300"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  <span className="font-medium">Kembali</span>
                </motion.button>
              </div>
            </div>
          </div>
        </motion.div>

        {/* ==================== FILTER SECTION ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex items-center gap-2">
              <FaFilter className="text-gray-500" />
              <h2 className="text-lg font-semibold text-gray-800">Filter Statistik</h2>
            </div>

            <div className="flex flex-wrap gap-3">
              {/* Filter Periode */}
              <SipDropdown
                value={selectedPeriod}
                onChange={(e) => setSelectedPeriod(e.target.value)}
                className="w-40"
                filter={false}
                options={[
                  { label: "Hari Ini", value: "hari" },
                  { label: "Minggu Ini", value: "minggu" },
                  { label: "Bulan Ini", value: "bulan" },
                  { label: "Tahun Ini", value: "tahun" },
                ]}
              />
              <SipDropdown
                value={selectedModule}
                onChange={(e) => setSelectedModule(e.target.value)}
                className="w-48"
                filter={false}
                options={[
                  { label: "Semua Modul", value: "semua" },
                  { label: "ATK", value: "atk" },
                  { label: "Inventaris Lab", value: "inventaris" },
                  { label: "Perawatan Aset", value: "perawatan" },
                  { label: "Audit Keamanan", value: "audit" },
                ]}
              />
            </div>
          </div>
        </motion.div>

        {/* ==================== OVERVIEW CARDS ==================== */}
        <motion.div
          className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {overviewData.map((item, index) => (
            <motion.div
              key={index}
              className={`${item.color} rounded-2xl p-6 text-white shadow-md hover:shadow-lg transition-all duration-200`}
              whileHover={{ scale: 1.02, y: -5 }}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-white/80 text-sm font-medium">{item.title}</p>
                  <p className="text-3xl font-bold mt-1">{item.value}</p>
                  <div className="flex items-center gap-1 mt-2">
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      item.changeType === 'positive' ? 'bg-white/20' : 'bg-red-500/20'
                    }`}>
                      {item.change}
                    </span>
                    <span className="text-xs text-white/70">vs bulan lalu</span>
                  </div>
                </div>
                <div className="p-3 bg-white/20 rounded-xl">
                  <item.icon className="text-2xl" />
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* ==================== CHARTS SECTION ==================== */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* ATK Stok Status - Pie Chart */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <div className="flex items-center gap-2 mb-6">
              <FaBuilding className="text-primary" />
              <h3 className="text-lg font-semibold text-gray-800">Status Stok ATK</h3>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={atkStokData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {atkStokData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
          </motion.div>

          {/* Inventaris Lab Kondisi - Bar Chart */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <div className="flex items-center gap-2 mb-6">
              <FaFlask className="text-secondary" />
              <h3 className="text-lg font-semibold text-gray-800">Kondisi Inventaris Lab</h3>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={inventarisLabKondisiData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Bar dataKey="jumlah" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </motion.div>

          {/* Perawatan Aset Status - Area Chart */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <div className="flex items-center gap-2 mb-6">
              <FaTv className="text-purple-600" />
              <h3 className="text-lg font-semibold text-gray-800">Status Perawatan Aset</h3>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <AreaChart data={perawatanStatusData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Area type="monotone" dataKey="jumlah" stroke={COLORS.purple} fill={COLORS.purple} fillOpacity={0.6} />
              </AreaChart>
            </ResponsiveContainer>
          </motion.div>

          {/* Audit Keamanan - Radial Bar Chart */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <div className="flex items-center gap-2 mb-6">
              <FaShieldAlt className="text-orange-600" />
              <h3 className="text-lg font-semibold text-gray-800">Status Audit Keamanan</h3>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <RadialBarChart cx="50%" cy="50%" innerRadius="10%" outerRadius="80%" data={auditKeamananStatusData}>
                <RadialBar dataKey="value" cornerRadius={10} />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
              </RadialBarChart>
            </ResponsiveContainer>
          </motion.div>
        </div>

        {/* ==================== TREND ANALYSIS ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.7 }}
        >
          <div className="flex items-center gap-2 mb-6">
            <FaCalendarAlt className="text-info" />
            <h3 className="text-lg font-semibold text-gray-800">Trend Aktivitas Bulanan</h3>
          </div>
          <ResponsiveContainer width="100%" height={400}>
            <ComposedChart data={trendBulananData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="bulan" />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Legend />
              <Area type="monotone" dataKey="atk" stackId="1" stroke={COLORS.primary} fill={COLORS.primary} fillOpacity={0.6} />
              <Area type="monotone" dataKey="inventaris" stackId="1" stroke={COLORS.secondary} fill={COLORS.secondary} fillOpacity={0.6} />
              <Line type="monotone" dataKey="perawatan" stroke={COLORS.warning} strokeWidth={3} />
              <Line type="monotone" dataKey="audit" stroke={COLORS.danger} strokeWidth={3} />
            </ComposedChart>
          </ResponsiveContainer>
        </motion.div>

        {/* ==================== STATISTIK INVENTARIS BERDASARKAN TAHUN ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.75 }}
        >
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-2">
              <FaChartBar className="text-indigo-600" />
              <h3 className="text-lg font-semibold text-gray-800">Statistik Inventaris Berdasarkan Tahun</h3>
            </div>
            <div className="text-sm text-gray-500">
              Total {asets.length} item inventaris
            </div>
          </div>
          
          {/* Summary Cards untuk Inventaris */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-primary/5 rounded-lg p-4 border border-secondary">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-blue-600 text-sm font-medium">Total Inventaris</p>
                  <p className="text-2xl font-bold text-blue-800">
                    {asets.length > 0 && asets[0].hasOwnProperty('total') 
                      ? asets.reduce((sum, item) => sum + item.total, 0)
                      : asets.length
                    }
                  </p>
                  <p className="text-xs text-blue-500">
                    Semua kategori
                  </p>
                </div>
                <div className="p-2 bg-blue-200 rounded-lg">
                  <FaBuilding className="text-blue-600" />
                </div>
              </div>
            </div>
            
            <div className="bg-accent/5 rounded-lg p-4 border border-secondary">
              <div className="flex items-center justify-between">
                <div>
                <p className="text-green-600 text-sm font-medium">
                    {(() => {
                      if (asets.length > 0 && asets[0].hasOwnProperty('tahun')) {
                        const sortedData = asets.sort((a, b) => b.tahun - a.tahun);
                        return `Tahun ${sortedData[0]?.tahun || new Date().getFullYear()}`;
                      } else {
                        return `Tahun ${new Date().getFullYear()}`;
                      }
                    })()}
                  </p>
                  <p className="text-2xl font-bold text-green-800">
                    {(() => {
                      if (asets.length > 0 && asets[0].hasOwnProperty('tahun') && asets[0].hasOwnProperty('total')) {
                        const sortedData = asets.sort((a, b) => b.tahun - a.tahun);
                        return sortedData[0]?.total || 0;
                      } else {
                        const currentYear = new Date().getFullYear();
                        return asets.filter(item => dayjs(item.tgl).year() === currentYear).length;
                      }
                    })()}
                  </p>
                  <p className="text-xs text-green-500">Item masuk</p>
                </div>
                <div className="p-2 bg-green-200 rounded-lg">
                  <FaCalendarAlt className="text-green-600" />
                </div>
              </div>
            </div>
            
            <div className="bg-primary/5 rounded-lg p-4 border border-secondary">
              <div className="flex items-center justify-between">
                <div>
                <p className="text-purple-600 text-sm font-medium">
                    {(() => {
                      if (asets.length > 0 && asets[0].hasOwnProperty('tahun')) {
                        const sortedData = asets.sort((a, b) => b.tahun - a.tahun);
                        return `Tahun ${sortedData[1]?.tahun || (new Date().getFullYear() - 1)}`;
                      } else {
                        return `Tahun ${new Date().getFullYear() - 1}`;
                      }
                    })()}
                  </p>
                  <p className="text-2xl font-bold text-purple-800">
                    {(() => {
                      if (asets.length > 0 && asets[0].hasOwnProperty('tahun') && asets[0].hasOwnProperty('total')) {
                        const sortedData = asets.sort((a, b) => b.tahun - a.tahun);
                        return sortedData[1]?.total || 0;
                      } else {
                        const lastYear = new Date().getFullYear() - 1;
                        return asets.filter(item => dayjs(item.tgl).year() === lastYear).length;
                      }
                    })()}
                  </p>
                  <p className="text-xs text-purple-500">Item masuk</p>
                </div>
                <div className="p-2 bg-purple-200 rounded-lg">
                  <FaCalendarAlt className="text-purple-600" />
                </div>
              </div>
            </div>
            
            <div className="bg-warning/5 rounded-lg p-4 border border-secondary">
              <div className="flex items-center justify-between">
                <div>
                <p className="text-orange-600 text-sm font-medium">
                    {(() => {
                      if (asets.length > 0 && asets[0].hasOwnProperty('tahun')) {
                        const sortedData = asets.sort((a, b) => b.tahun - a.tahun);
                        return `Tahun ${sortedData[2]?.tahun || (new Date().getFullYear() - 2)}`;
                      } else {
                        return `Tahun ${new Date().getFullYear() - 2}`;
                      }
                    })()}
                  </p>
                  <p className="text-2xl font-bold text-orange-800">
                    {(() => {
                      if (asets.length > 0 && asets[0].hasOwnProperty('tahun') && asets[0].hasOwnProperty('total')) {
                        const sortedData = asets.sort((a, b) => b.tahun - a.tahun);
                        return sortedData[2]?.total || 0;
                      } else {
                        const twoYearsAgo = new Date().getFullYear() - 2;
                        return asets.filter(item => dayjs(item.tgl).year() === twoYearsAgo).length;
                      }
                    })()}
                  </p>
                  <p className="text-xs text-orange-500">Item masuk</p>
                </div>
                <div className="p-2 bg-orange-200 rounded-lg">
                  <FaCalendarAlt className="text-orange-600" />
                </div>
              </div>
            </div>
          </div>

          {/* Bar Chart Berdasarkan Tahun */}
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={inventarisTahunData()} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis 
                dataKey="tahun" 
                tick={{ fontSize: 12 }}
                axisLine={{ stroke: '#e0e0e0' }}
                tickLine={{ stroke: '#e0e0e0' }}
              />
              <YAxis 
                tick={{ fontSize: 12 }}
                axisLine={{ stroke: '#e0e0e0' }}
                tickLine={{ stroke: '#e0e0e0' }}
              />
              <Tooltip 
                content={({ active, payload, label }) => {
                  if (active && payload && payload.length) {
                    return (
                      <div className="bg-white p-4 border border-gray-200 rounded-lg shadow-lg">
                        <p className="font-semibold text-gray-900 mb-2">Tahun {label}</p>
                        {payload.map((entry, index) => (
                          <p key={index} style={{ color: entry.color }} className="text-sm">
                            Jumlah Item: <span className="font-medium">{entry.value}</span>
                          </p>
                        ))}
                      </div>
                    );
                  }
                  return null;
                }}
              />
              <Legend 
                wrapperStyle={{ paddingTop: '20px' }}
                iconType="rect"
              />
              <Bar 
                dataKey="jumlah" 
                name="Jumlah Inventaris"
                fill={COLORS.primary} 
                radius={[4, 4, 0, 0]}
                maxBarSize={80}
              />
            </BarChart>
          </ResponsiveContainer>

          {/* Insight Section */}
          <div className="mt-6 p-4 bg-secondary/50 rounded-lg border border-secondary">
            <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <FaChartBar className="text-indigo-600" />
              Analisis Data Inventaris Berdasarkan Tahun
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-gray-700">
                  <span className="font-medium text-blue-600">📊 Tahun Terbanyak:</span> 
                  {(() => {
                    if (asets.length > 0 && asets[0].hasOwnProperty('tahun') && asets[0].hasOwnProperty('total')) {
                      const maxItem = asets.reduce((max, item) => item.total > max.total ? item : max, asets[0]);
                      const totalItems = asets.reduce((sum, item) => sum + item.total, 0);
                      return `${maxItem.tahun} dengan ${maxItem.total} item (${((maxItem.total / totalItems) * 100).toFixed(1)}%)`;
                    } else {
                      const tahun2024Count = asets.filter(item => dayjs(item.tgl).year() === 2024).length;
                      return `2024 dengan ${tahun2024Count} item (${((tahun2024Count / asets.length) * 100).toFixed(1)}%)`;
                    }
                  })()}
                </p>
              </div>
              <div>
                <p className="text-gray-700">
                  <span className="font-medium text-green-600">📈 Trend Pertumbuhan:</span> 
                  {(() => {
                    if (asets.length > 0 && asets[0].hasOwnProperty('tahun') && asets[0].hasOwnProperty('total')) {
                      const sortedData = asets.sort((a, b) => a.tahun - b.tahun);
                      if (sortedData.length >= 2) {
                        const firstYear = sortedData[0];
                        const lastYear = sortedData[sortedData.length - 1];
                        const growth = ((lastYear.total - firstYear.total) / firstYear.total * 100).toFixed(1);
                        return `${growth > 0 ? 'Peningkatan' : 'Penurunan'} ${Math.abs(growth)}% dari ${firstYear.tahun} ke ${lastYear.tahun}`;
                      }
                      return 'Data tidak cukup untuk analisis trend';
                    } else {
                      return 'Peningkatan signifikan dari 2022 ke 2024 menunjukkan investasi infrastruktur yang konsisten';
                    }
                  })()}
                </p>
              </div>
              <div>
               
              </div>
              <div>
                <p className="text-gray-700">
                  <span className="font-medium text-orange-600">📅 Periode Data:</span> 
                  {(() => {
                    if (asets.length > 0 && asets[0].hasOwnProperty('tahun') && asets[0].hasOwnProperty('total')) {
                      const years = asets.map(item => item.tahun).sort((a, b) => a - b);
                      const minYear = Math.min(...years);
                      const maxYear = Math.max(...years);
                      return `${minYear} - ${maxYear} (${years.length} tahun)`;
                    } else if (asets.length > 0) {
                      const latestItem = asets.sort((a, b) => new Date(b.tgl) - new Date(a.tgl))[0];
                      return `${latestItem?.desc} (${dayjs(latestItem?.tgl).format('DD/MM/YYYY')})`;
                    } else {
                      return 'Tidak ada data tersedia';
                    }
                  })()}
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* ==================== SUMMARY INSIGHTS ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.8 }}
        >
          <div className="flex items-center gap-2 mb-6">
            <FaClipboardList className="text-indigo-600" />
            <h3 className="text-lg font-semibold text-gray-800">Ringkasan & Insight</h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Insight ATK */}
            <div className="bg-blue-50 rounded-xl p-4 border border-blue-200">
              <h4 className="font-semibold text-blue-800 mb-2">📦 ATK</h4>
              <p className="text-sm text-blue-700">
                {atkData.filter(item => item.status === "Habis").length > 0 
                  ? `⚠️ ${atkData.filter(item => item.status === "Habis").length} item ATK memerlukan restok segera`
                  : "✅ Semua stok ATK dalam kondisi baik"
                }
              </p>
            </div>

            {/* Insight Inventaris Lab */}
            <div className="bg-green-50 rounded-xl p-4 border border-green-200">
              <h4 className="font-semibold text-green-800 mb-2">🧪 Inventaris Lab</h4>
              <p className="text-sm text-green-700">
                {inventarisLabData.filter(item => item.kondisi?.toLowerCase() === "rusak").length > 0
                  ? `🔧 ${inventarisLabData.filter(item => item.kondisi?.toLowerCase() === "rusak").length} peralatan lab perlu perbaikan`
                  : "✅ Semua peralatan lab dalam kondisi baik"
                }
              </p>
            </div>

            {/* Insight Perawatan Aset */}
            <div className="bg-purple-50 rounded-xl p-4 border border-purple-200">
              <h4 className="font-semibold text-purple-800 mb-2">🔧 Perawatan Aset</h4>
              <p className="text-sm text-purple-700">
                {perawatanAsetData.filter(item => item.status === "proses").length > 0
                  ? `⏳ ${perawatanAsetData.filter(item => item.status === "proses").length} aset sedang dalam proses perawatan`
                  : "✅ Tidak ada aset yang sedang dalam perawatan"
                }
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default StatistikPage;